export { default } from "@components/VaultTabs/Claims";
